import { render, staticRenderFns } from "./BaseCampaignConsentItem.vue?vue&type=template&id=36ded0f0&scoped=true"
import script from "./BaseCampaignConsentItem.vue?vue&type=script&lang=js"
export * from "./BaseCampaignConsentItem.vue?vue&type=script&lang=js"
import style0 from "./BaseCampaignConsentItem.vue?vue&type=style&index=0&id=36ded0f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ded0f0",
  null
  
)

export default component.exports